import React, { useEffect, useState } from 'react'
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate
} from "react-router-dom"
import {
  Box,
  CssBaseline,
  Toolbar,
} from '@mui/material'

import Aos from 'aos'
import 'aos/dist/aos.css'

import { AppProvider } from './context/context/context.js'
import Main from './pages/main/main.js'
import Work from './pages/work/work.js'
import Contact from './pages/contact/contact.js'
import ResponsiveAppBar from './components/navbar/navbar.js'
import Footer from './components/footer/footer.js'
import Preloading from "./pages/preloading/preloading.js"
import CursorContextProvider from './context/cursor/context.js'
import Cursor from './components/cursor/cursor.js'

const App = () => {
  const [preloading, setPreloading] = useState(true)

  useEffect(() => {
    setTimeout(() => { setPreloading(false) }, 2200)
    console.clear()

    console.log("%c YOUSSEF MOHAMMED PORTFOLIO",
      `color:#DEDEDC;
      font-size:75px;
      font-weight:bold;
      font-family: League Gothic, sans-serif;`)

    Aos.init({ duration: 1000 })
  }, [])

  return <CursorContextProvider>
    <AppProvider>
      {preloading
        ? <Preloading />
        : <React.Fragment>
          <CssBaseline />
          <Router>
            <Box sx={{ bgcolor: '#141414' }} overflow={"hidden"}>
              <Cursor />

              <ResponsiveAppBar />
              <Toolbar />
              <Toolbar />
              <Routes>
                <Route exact path='/' element={<Main />} />
                <Route exact path='/mywork' element={<Work />} />
                <Route exact path='/contact' element={<Contact />} />

                <Route path="*" element={<Navigate replace to="/" />} />
              </Routes>
              <Toolbar />
              <Footer />
            </Box>
          </Router>
        </React.Fragment>
      }
    </AppProvider>
  </CursorContextProvider>

}

export default App
